<template>
  <div class="fsw-container">
    <h1>FSWP项目</h1>
    <div class="subtitle">EE快速通道</div>
    
    <div class="content">
      <h2>基本要求：</h2>
      <ul>
        <li>
          <strong>专业工作经验：</strong>过去10年中有1年连续的、全职或相同时间的兼职的NOC TEER 0、1，2，3类的工作经验（全职为1560个小时/年，即30个小时/每周或兼职15个小时/每周），工作经验可以是在加拿大境内或境外获得
        </li>
        <li>
          <strong>语言：</strong>所有四个单项都要达到CLB 7级或以上（雅思是四个单项达到6分或以上）
        </li>
        <li>
          <strong>学历：</strong>高中毕业及以上
        </li>
        <li>
          <strong>资金要求：</strong>½ 最低收入标准的安置资金（如有工作则不需要）
        </li>
        <li>
          <strong>居住地：</strong>居住在Quebec以外的其它省份或地区
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FSWView'
}
</script>

<style scoped>
.fsw-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

h1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
}

h2 {
  font-size: 24px;
  color: #333;
  margin: 30px 0 20px;
}

.content {
  font-size: 16px;
  line-height: 1.8;
  color: #444;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 20px;
  padding-left: 20px;
  position: relative;
}

li:before {
  content: '•';
  position: absolute;
  left: 0;
  color: #666;
}

strong {
  color: #333;
}
</style>